import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { faShoppingCart } from '@fortawesome/free-solid-svg-icons';
import { ShowBasketButtonType } from 'src/app/modules/general/models/show-basket-button-type';
import { ShopSettingsService } from 'src/app/modules/general/services/shop-settings.service';
import { GiftCardStepEnum } from 'src/app/modules/giftcard/models/giftcard-step.enum';
import { GiftCardStepService } from 'src/app/modules/giftcard/services/giftcard-step.service';
import { Order } from 'src/app/modules/order/models/order';
import { OrderLine } from 'src/app/modules/order/models/order-line';
import { OrderTypeEnum } from 'src/app/modules/order/models/order-type.enum';
import { OrderStateService } from 'src/app/modules/order/services/order-state.service';

@Component({
  selector: 'app-basket-button',
  templateUrl: './basket-button.component.html',
  styleUrls: ['./basket-button.component.css']
})
export class BasketButtonComponent implements OnInit {

  @Input()
  showIcon: boolean;

  faShoppingCart = faShoppingCart;

  constructor(
    private orderStateService: OrderStateService,
    private giftCardStepService: GiftCardStepService,
    private shopSettingsService: ShopSettingsService,
    private router: Router,
  ) {
  }

  ngOnInit(): void {
  }

  get order(): Order {
    return this.orderStateService.order;
  }

  get visible(): boolean {
    return this.showBasketButtonOnHeaderMode !== ShowBasketButtonType.None && !this.isKiosk;
  }

  public get isKiosk(): boolean {
    return this.router.url.startsWith('/kiosk');
  }

  get showBasketButtonOnHeaderMode(): ShowBasketButtonType {
    return this.shopSettingsService?.shopSettings?.showBasketButtonType || ShowBasketButtonType.None;
  }

  onClick(): void {
    if (this.isOrderDone) {
      return;
    }

    switch (this.order?.orderType) {
      case OrderTypeEnum.Giftcard:
        this.giftCardStepService.setStep(GiftCardStepEnum.SelectGiftCard);
        this.giftCardStepService.update(GiftCardStepEnum.SelectGiftCard);
        return;
      default:
        break;
    }
  }

  get orderLines(): OrderLine[] {
    return this.order?.orderLines || [];
  }

  get count(): number {
    if (this.isOrderDone) {
      return 0;
    }

    switch (this.showBasketButtonOnHeaderMode) {
      case ShowBasketButtonType.LineCount:
        const lineCount = this.orderLines.filter(x => x.quantity > 0).length;
        return lineCount;
      case ShowBasketButtonType.ItemsCount:
        let itemsCount = 0;
        this.orderLines.forEach(orderLine => {
          itemsCount += orderLine.quantity;
        });
        return itemsCount;
      default:
        return 0;
    }
  }

  get isOrderDone(): boolean {
    return this.order?.state === 'done';
  }
}
